
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'HowBuyBlock',

    methods: {
        getSvgUrl(iconId) {
            return this.extras?.icons?.[iconId] || '';
        },
    },
});
